










































import Vue from 'vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import SelectButton from '@/components/modal/basics/SelectButton.vue'
import Dropdown from '@/components/globals/basics/Dropdown.vue'

export interface PriceRange {
  from: number | null
  to: number | null
}

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    SelectButton,
    Dropdown,
  },
  props: {
    name: {
      type: String as () => string,
      default: 'PriceModal',
    },
    value: {
      type: Object as () => PriceRange,
      default: () => ({ from: null, to: null }),
    },
  } as const,
  data() {
    return {
      from: null as number | null,
      to: null as number | null,
    }
  },
  computed: {
    isInvalid(): boolean {
      return (this.from || this.from === 0) && (this.to || this.to === 0)
        ? this.to < this.from
        : false
    },
    priceOptionsFrom(): object[] {
      return [
        { text: '指定なし', value: null },
        { text: '500pt', value: 500 },
        { text: '1,500pt', value: 1500 },
        { text: '2,000pt', value: 2000 },
        { text: '2,500pt', value: 2500 },
        { text: '3,000pt', value: 3000 },
        { text: '3,500pt', value: 3500 },
        { text: '4,000pt', value: 4000 },
        { text: '4,500pt', value: 4500 },
        { text: '5,000pt', value: 5000 },
        { text: '5,500pt', value: 5500 },
        { text: '6,000pt', value: 6000 },
        { text: '6,500pt', value: 6500 },
        { text: '7,000pt', value: 7000 },
        { text: '7,500pt', value: 7500 },
        { text: '8,000pt', value: 8000 },
        { text: '8,500pt', value: 8500 },
        { text: '9,000pt', value: 9000 },
        { text: '9,500pt', value: 9500 },
        { text: '10,000pt', value: 10000 },
      ]
    },
    priceOptionsTo(): object[] {
      return this.priceOptionsFrom
    },
  },
  watch: {
    from: function (from: number | null) {
      if (this.to && from && this.to <= from) {
        this.to = null
      }
    },
    to: function (to: number | null) {
      if (this.from && to && to <= this.from) {
        this.from = null
      }
    },
  },
  methods: {
    onSubmit(): void {
      this.$emit('submit', {
        from: this.from || this.from === 0 ? this.from : null,
        to: this.to || this.to === 0 ? this.to : null,
      })
      this.$modal.pop()
    },
    beforeOpen(): void {
      this.from = this.value.from
      this.to = this.value.to
    },
    beforeClose(): void {
      // 閉じる前に内部の値は全て初期化しておく
      this.from = null
      this.to = null
    },
  },
})
